












































































































import { Component, Vue } from 'vue-property-decorator'
import TransitAuth from '@/components/TransitAuth.vue'
import { vxm } from '@/store/'

@Component({
  components: {
    TransitAuth
  }
})
export default class MainHeader extends Vue {
  private search: string = ''

  get allProviders() {
    return vxm.dappservices.getAllProviders
  }

  get isMobile() {
    return vxm.core.isMobile
  }

  get showSearch() {
    return vxm.core.showSearch
  }

  set showSearch(value) {
    vxm.core.setShowSearch(value)
  }

  get getLanguage() {
    return vxm.core.language
  }

  get showLangSelect() {
    return vxm.core.settings.showLangSelect
  }

  setLanguage(lang: string) {
    vxm.core.setLanguage(lang)
  }

  onSubmit(evt: any) {
    let searchString = this.search.toLowerCase()
    evt.preventDefault()
    if (this.allProviders.find((p: any) => p.name === searchString)) {
      this.$router.push({
        name: 'PrvDetails',
        params: { provider: searchString }
      })
    } else {
      this.$router.push({
        name: 'AccountDetails',
        params: { account: searchString }
      })
    }
    this.search = ''
    this.showSearch = false
  }
}
